import React, { useMemo, useRef } from "react";
import { Button, FormHelperText } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import CloseIcon from "@mui/icons-material/Close";

const humanSize = (bytes) =>
  bytes ? `${(bytes / (1024 * 1024)).toFixed(2)} MB` : "";

const UploadImage = ({
  name,
  label = "Upload image",
  value, // File | string | null
  onChange, // (file|null) => void
  accept = ".jpg,.jpeg,.png,.svg,.gif,.webp",
  maxSizeMB = 10,
  required = false,
  error = "",
  className = "",
  showPreview = true,
}) => {
  const inputRef = useRef(null);
  const previewUrl = useMemo(() => {
    if (!value) return null;

    // Ako je File, generiši URL iz memorije
    if (value instanceof File && typeof URL !== "undefined") {
      return URL.createObjectURL(value);
    }

    // Ako je string (putanja iz backenda), koristi ga direktno
    if (typeof value === "string") {
      return value.startsWith("http")
        ? value
        : `${window.location.origin}${value}`;
    }

    return null;
  }, [value]);
  const triggerInput = () => inputRef.current?.click();

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isValidType = /image\/(jpeg|png)/i.test(file.type);
    const isValidSize = file.size <= maxSizeMB * 1024 * 1024;

    if (!isValidType) {
      onChange?.(null);
      return;
    }
    if (!isValidSize) {
      onChange?.(null);
      return;
    }
    onChange?.(file);
  };

  const clearFile = () => {
    if (inputRef.current) inputRef.current.value = "";
    onChange?.(null);
  };

  return (
    <div className={className}>
      <input
        ref={inputRef}
        id={`file-input-${name}`}
        name={name}
        type="file"
        hidden
        accept={accept}
        onChange={handleFileSelect}
      />

      <div className="flex items-center gap-2 ">
        <Button
          variant="contained"
          size="small"
          startIcon={<FileUploadOutlinedIcon />}
          onClick={triggerInput}
          className="default-btn-primary w-100 mb-1"
        >
          {label}
        </Button>

        {value instanceof File && (
          <span style={{ fontSize: 12 }}>
            {value.name} ({humanSize(value.size)})
          </span>
        )}
      </div>

      {showPreview && value && previewUrl && (
        <div
          className="preview-image-holder"
          style={{
            width: "100%",
            border: "1px dashed #e0e0e0",
            borderRadius: 8,
            padding: 8,
            textAlign: "center",
            marginBottom: 8,
          }}
        >
          <div className="preview-image-remove" onClick={clearFile}>
            <CloseIcon />
          </div>
          <img
            src={previewUrl}
            alt="preview"
            style={{ maxWidth: "100%", maxHeight: 180, objectFit: "contain" }}
            onLoad={() => URL.revokeObjectURL(previewUrl)}
          />
        </div>
      )}
    </div>
  );
};

export default UploadImage;
